export type AgencyKnowledgeCategory =
  | 'destination'
  | 'product'
  | 'airline'
  | 'supplier'
  | 'general';

export interface AgencyKnowledgeDto {
  id: string;
  title: string;
  category: AgencyKnowledgeCategory;
  content: string;
  tags: string[];
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateAgencyKnowledgePayload {
  title: string;
  category: AgencyKnowledgeCategory;
  content: string;
  tags: string[];
  isActive?: boolean;
}

export interface UpdateAgencyKnowledgePayload {
  title?: string;
  category?: AgencyKnowledgeCategory;
  content?: string;
  tags?: string[];
  isActive?: boolean;
}

export const CATEGORY_LABELS: Record<AgencyKnowledgeCategory, string> = {
  destination: 'Destino',
  product: 'Producto',
  airline: 'Aerolínea',
  supplier: 'Proveedor',
  general: 'General',
};
